import * as React from 'react';
import BaseClient from '../../../../models/base-client';
import TertiaryButton from '../../../common/tertiary-button';
import { withRouter, RouteComponentProps } from 'react-router';
import Paths from '../../../../models/enums/paths';

interface Props extends RouteComponentProps {
  client: BaseClient;
  isClientAdmin: boolean;
}

/**
 * ClientActionCell
 * @function ClientActionCell
 */
const ClientActionCell = ({ client, isClientAdmin, history }: Props) => {
  const redirectToEditClientId = (clientId) => {
    if (isClientAdmin) {
      history.push(Paths.ClientDashboards.replace(':clientId', clientId.toString()));
    } else {
      history.push(Paths.EditClient.replace(':clientId', clientId.toString()));
    }
  };

  return (
    <td>
      <TertiaryButton
        text="Edit Client"
        title="Edit Client"
        handleClick={() => redirectToEditClientId(client.clientId)}
      />
    </td>
  );
};

export default withRouter(ClientActionCell);
